a.popup = (function(){
	var my = {
		winlist:[],
		funcListOnRemove:{},
		create:function(s){
			var slideFrom = s.slideFrom || 'fromleft';
			var inpc = s.content || '<div class="loader inline"><i class="fa fa-sync fa-spin"></i></div>';
			var title = s.title || '';
			var disable_topbar = s.disable_topbar || false;
			var disable_back = s.disable_back || false;
			var css_class = s.css_class || '';
			var winbar_action_icon = s.winbar_action_icon || undefined;
			var winbar_action = s.winbar_action || function(){ console.log('WinBar action function missing'); };
			var f_ready = s.ready || function(){};
			var f_close = s.close || function(){};
			var token = a.shared.createToken();
			var changeHash = false;
			my.funcListOnRemove[token] = f_close;
			// Create popup window
			var cnt = '';
			cnt += '<div class="popup ';
			cnt += slideFrom+' ';
			cnt += css_class+' ';
			cnt += '" id="popupid_'+token+'">';
			if (!disable_topbar) {
				cnt += '<div class="popupwinbar">';
				cnt += '<div class="back">';
				if (!disable_back) {
					cnt += '<i class="close fal fa-chevron-left"></i>';
					changeHash = true;
					
				}
				cnt += '</div>';
				cnt += '<h4>'+title+'</h4>';
				cnt += '<div class="action">';
				if (winbar_action_icon) {
					cnt += '<i class="fal fa-'+winbar_action_icon+'" data-action="winbar_action"></i>';
				}
				cnt += '</div>';
				cnt += '</div>';
			}
			cnt += '<div class="ic">'+inpc+'</div>';
			cnt += '</div>';
			if (my.winlist.length == 0) {
				// Create container
				$('body').append('<div id="popup_container"></div>');
				$('#popup_container').show();
			}
			// Change hash, if enabled
			if (changeHash) {
				location.hash = '/popupid/'+token+'/';
			}
			// Add to winlist, must come after hash change
			setTimeout(function(){
				my.winlist.push(token);
			},100);
			// Make other popups uncurrent
			$('#popup_container>.popup').attr('data-active-popup','false');
			// Add popup
			$('#popup_container').append(cnt).ready(function(){
				// Define window
				var pwin = $('#popupid_'+token);
				pwin.addClass('show');
				// Close button
				$('i.close',pwin).click(function(){
					window.history.back();
				});
				// Action button
				$('i[data-action="winbar_action"]',pwin).click(function(){
					winbar_action();
				});
				// Callback
				f_ready(token);
			});
		},
		remove:function(token,cb_close){
			var pwin = $('#popupid_'+token);
			pwin.removeClass('show');
			setTimeout(function(){
				pwin.remove();
				// Remove from winlist
				my.winlist.splice(my.winlist.indexOf(token),1);
				// If winlist is empty, remove #popup_container
				if (my.winlist.length == 0) {
					$('#popup_container').addClass('remove');
					setTimeout(function(){
						$('#popup_container').remove();
						cb_close();
					},100);
				}
				else {
					cb_close();
				}
			},200);
		},
		runOnRemove:function(token){
			my.funcListOnRemove[token]();
		},
		canRemoveLastWin:function(prev_token,curr_token,cb_remove){
			if (my.winlist.includes(prev_token) && my.winlist.includes(curr_token)) {
				cb_remove();
			}
		}
	}
	return my;
}());